// libs
import React, { memo } from 'react';

// helpers
import { getAkamaiUrl } from 'shared/helpers/utils';

// styles
import { Container, Blobs, BlobsCenter, Blob, Image } from './styles';

function ChunkFallback() {
  return (
    <Container>
      <Blobs>
        <BlobsCenter>
          <Image
            src={getAkamaiUrl(
              '/pub/static/frontend/Nykaa/theme001/en_US/Fermion_CustomCheckout/images/N.svg'
            )}
            alt="Nykaa Loader"
          />
        </BlobsCenter>
        <Blob />
        <Blob />
        <Blob />
        <Blob />
        <Blob />
        <Blob />
      </Blobs>
    </Container>
  );
}

export default memo(ChunkFallback, () => true);
